import React, { useState, useEffect } from "react";
import { Container, Paper, TextField, Typography } from "@material-ui/core";

import { useStyles } from "../../assets/styles";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import AddStore from "./AddStore";
import { connect } from "react-redux";
import { getRestaurants } from "../../actions/restaurants";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useForm } from "react-hook-form";

function EditStore({ returnNav, restaurants, getRestaurants }) {
	const [restaurant, setRestaurant] = useState();
	const { register, handleSubmit } = useForm();

	const classes = useStyles();
	useEffect(() => {
		if (restaurants.length === 0) {
			getRestaurants();
		}
	}, [restaurants, getRestaurants]);

	const pickRestaurant = ({ restaurant }) => {
		const pickedRestaurant = restaurants.find((rests) => rests.path === restaurant);
		setRestaurant(pickedRestaurant);
	};

	if (restaurant) {
		return <AddStore data={restaurant} returnNav={() => setRestaurant(null)} />;
	}

	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				<Typography variant="h4">Restaurantes</Typography>

				<TextField
					style={{ width: "300px", margin: 20 }}
					select
					SelectProps={{
						native: true,
						IconComponent: () => <ArrowDropDownIcon />,
					}}
					name="restaurant"
					inputRef={register({ required: true, minLength: 2 })}
				>
					{restaurants.map((store) => (
						<option key={store.path} value={store.path}>
							{store.name}
						</option>
					))}
				</TextField>
				<ButtonWithStyle onClick={handleSubmit(pickRestaurant)}>Elegir</ButtonWithStyle>
				<ButtonWithStyle onClick={returnNav}>Regresar</ButtonWithStyle>
			</Paper>
		</Container>
	);
}

const mapStateToProps = ({ restaurants }) => {
	return { restaurants };
};

export default connect(mapStateToProps, { getRestaurants })(EditStore);
